import { REVIEWER_NAME_DISPLAY_FORMAT } from "@apps/reviews/constants";

export const formatCustomerName = ({
    firstName,
    lastName,
    displayFormat,
}: {
    firstName: string | null;
    lastName: string | null;
    displayFormat: REVIEWER_NAME_DISPLAY_FORMAT;
}) => {
    const clean = (name: string | null) => name?.trim() || "";
    const formatInitials = (name: string | null) => {
        const cleanedName = clean(name).substring(0, 1);
        return cleanedName ? `${cleanedName}.` : "";
    };

    const firstNameClean = clean(firstName);
    const lastNameClean = clean(lastName);

    switch (displayFormat) {
        case REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_LAST_NAME:
            return `${firstNameClean} ${formatInitials(lastName)}`.trim();

        case REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_FULL_NAME:
            return `${formatInitials(firstName)} ${formatInitials(
                lastName
            )}`.trim();

        default:
            return `${firstNameClean} ${lastNameClean}`.trim();
    }
};
